import React, { useEffect, useState } from 'react';
import { useTheme } from '../../theme/ThemeContext';

export default function OtpInput({ value = '', onChange, disabled = false }) {
  const [internalValue, setInternalValue] = useState(value);
  const { theme } = useTheme();
  const isDark = theme.auth.containerBg === '#111827';
  const [isFocused, setIsFocused] = useState(false);
  
  // Sync internal state with prop value
  useEffect(() => {
    setInternalValue(value);
  }, [value]);
  
  const handleChange = (e) => {
    const input = e.target.value;
    const filtered = input.replace(/[^\d]/g, '').slice(0, 6);
    
    setInternalValue(filtered);
    
    // Always call onChange with the new value
    onChange?.(filtered);
  };
  
  return (
    <div style={{ marginBottom: 12 }}>
      <label htmlFor="otp" style={{ display: 'block', marginBottom: 4, fontWeight: 600, fontSize: 12, color: theme.auth.labelColor, letterSpacing: '0.2px' }}>
        Enter OTP
      </label>
      <input
        id="otp"
        type="text"
        inputMode="numeric"
        autoComplete="one-time-code"
        value={internalValue}
        onChange={handleChange}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        placeholder="Enter 6-digit OTP"
        maxLength="6"
        style={{
          width: '100%',
          padding: '12px 10px',
          fontSize: internalValue ? 20 : 15,
          letterSpacing: internalValue ? 6 : 0,
          textAlign: 'center',
          fontWeight: 600,
          border: `2px solid ${isFocused ? (isDark ? 'rgba(13, 148, 136, 0.6)' : 'rgba(15, 118, 110, 0.5)') : (isDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)')}`,
          borderRadius: 10,
          boxSizing: 'border-box',
          background: isDark ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.02)',
          color: theme.auth.inputText,
          transition: 'all 0.2s ease',
          outline: 'none',
          boxShadow: isFocused ? (isDark ? 'inset 0 1px 3px rgba(13, 148, 136, 0.1)' : 'inset 0 1px 3px rgba(15, 118, 110, 0.08)') : 'none',
          fontFamily: 'monospace',
        }}
        disabled={disabled}
      />
    </div>
  );
}
